import { render } from "./OTextarea.vue?vue&type=template&id=21029ad4&scoped=true"
import script from "./OTextarea.vue?vue&type=script&lang=js"
export * from "./OTextarea.vue?vue&type=script&lang=js"

import "./OTextarea.vue?vue&type=style&index=0&id=21029ad4&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21029ad4"]])

export default __exports__